import { Fragment } from "react";
import { useTranslation } from "react-i18next";

import { Stack } from "@mui/material";

import { transformUserAdditionalInfoData } from "../../../../../utils/helpers";

import { BoxWrapper } from "../../../../../components";
import { WidgetRow } from "../../../../../components/common/WidgetRow/WidgetRow";
import { Button } from "../../../../../components/ui/Button/Button";
import { addStyles } from "./addStyles";
import { useTranslateData } from "./data";

import { Divider } from "../../../../../components/ui/Divider/Divider.styled";

export const UserAdditionalInfo = ({ showButton, restartTest, backData }) => {
  let data = useTranslateData();

  if (backData) {
    data = transformUserAdditionalInfoData(data, backData);
  }
  const { t } = useTranslation();

  return (
    <BoxWrapper addStyles={addStyles.boxWrapper}>
      <Divider addStyles={addStyles.divider} />
      <Stack spacing={3} divider={<Divider />}>
        {data?.map((items, idx) => (
          <Fragment key={idx}>
            <Stack key={idx} direction="column" spacing={2}>
              {items.map((item, ind) => (
                <WidgetRow key={ind} item={item} />
              ))}
            </Stack>
            {idx === data.length - 1 && !showButton && (
              <Button onClick={restartTest}>
                {t("anonymityCheck.buttonReload")}
              </Button>
            )}
          </Fragment>
        ))}
      </Stack>
    </BoxWrapper>
  );
};
